import { api, queryString, type Items } from '@sentinel/web-core';
import type {
  Sensor,
  SensorCreate,
  SensorCredentials,
  SensorReadings,
  SensorUpdate,
} from '@sentinel/shared';

/** Sensors of the organization (ADR 0030): hydrometers publishing over MQTT. */
export const sensorEndpoints = {
  list: () => api<Items<Sensor>>('/sensors'),
  create: (body: SensorCreate) => api<SensorCredentials>('/sensors', { method: 'POST', body }),
  update: (id: string, body: SensorUpdate) =>
    api<Sensor>(`/sensors/${id}`, { method: 'PATCH', body }),
  renewPassword: (id: string) =>
    api<SensorCredentials>(`/sensors/${id}/password`, { method: 'POST' }),
  remove: (id: string) => api<undefined>(`/sensors/${id}`, { method: 'DELETE' }),
  readings: (id: string, period: { from: string; to: string }) =>
    api<SensorReadings>(`/sensors/${id}/readings${queryString(period)}`),
};
